import { List, Record } from 'immutable';
import { schema } from 'normalizr';

export const ProofOfPerformanceReport = new Record({
  id: undefined,
  report_date: undefined,
  passed: undefined,
  always_on: undefined,
  schedule_1_on: undefined,
  schedule_1_off: undefined,
  schedule_2_on: undefined,
  schedule_2_off: undefined,
  schedule_3_on: undefined,
  schedule_3_off: undefined,
  schedule_4_on: undefined,
  schedule_4_off: undefined,
  legacy_alarm_string: undefined,
  relay_load: undefined,
  alarms: List(),
  status_received: undefined,
});

export const proofOfPerformanceReportSchema = new schema.Entity('proofOfPerformanceReports');

// for reading in nested models, object with { field: schema }
// ProofOfPerformanceReportSchema.define({  });
